<template>
  <v-app>
    <Cover>
      <div slot="body" style="text-align: center; margin-top: -95px">
        <img
          v-if="paymentStatus.omise_status === 'successful'"
          src="@/assets/img/ecommerce/shopping_cart@4x.png"
          alt="shopping cart"
          style="width: 140px; padding-bottom: 10px"
        />
        <img
          v-else
          src="@/assets/img/ecommerce/shopping_cart_out@4x.png"
          alt="empty shopping cart"
          style="width: 140px; padding-bottom: 10px"
        />
        <p>Order ID: {{ paymentStatus.order_id }}</p>
        <p>
          {{
            paymentStatus.omise_status === 'successful'
              ? $t('Payment Successfully')
              : $t('This order has been reset, please try to order again.')
          }}
        </p>
        <v-btn outline color="primary" @click="goToShop()">
          {{ $t('Continue Shopping') }}
        </v-btn>
      </div>
    </Cover>
  </v-app>
</template>
<script>
import { omiseApi } from '@/api/omise.js'
import { pageApi } from '@/api/page.js'
import Cover from '@/components/Cover.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    Cover
  },
  data() {
    return {
      paymentStatus: null
    }
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    })
  },
  mounted() {
    this.handleFetchPageProfile()
  },
  methods: {
    goToShop() {
      if (this.$route.query.redirect_url) {
        window.location.href = decodeURIComponent(
          this.$route.query.redirect_url
        )
      }
    },
    async handleFetchPageProfile() {
      try {
        const response = await pageApi.getPageProfile({
          pageId: this.$route.query.page_id
        })
        const {
          status,
          data: { pageprofile }
        } = response
        if (status === 200) {
          this.handleFetchPaymentStatus({
            pageId: pageprofile.pageid
              ? pageprofile.pageid
              : this.$route.query.page_id,
            pageToken: pageprofile.page_token,
            orderId: this.$route.query.order_id
          })
        }
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
      }
    },
    async handleFetchPaymentStatus({ pageId, pageToken, orderId }) {
      try {
        if (!pageId || !pageToken || !orderId) return
        const response = await omiseApi.getOmisePaymentStatus({
          page_id: pageId,
          page_token: pageToken,
          order_id: orderId
        })
        const {
          status,
          data: { data }
        } = response
        if (status === 200) {
          this.paymentStatus = data
        }
      } catch (error) {
        this.$swal({
          title: 'เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง',
          type: 'error',
          confirmButtonText: this.$t('Confirm')
        })
      }
    }
  }
}
</script>
